import { Controller } from "@hotwired/stimulus"

// One dashboard queue keeps shared totals in step with every saved series.
export default class extends Controller {
  connect() {
    this.queue = new Set()
    this.pending = null
  }

  disconnect() {
    this.queue.clear()
    this.pending = null
  }

  submit(event) {
    const form = event.currentTarget
    form.dataset.status = form.elements.campaign_status.value
    form.querySelector("[data-campaign-status-label]").textContent = form.elements.campaign_status.selectedOptions[0].text
    this.queue.add(form)
    this.saveNext()
  }

  saveNext() {
    if (this.pending) return
    for (const form of this.queue) {
      this.queue.delete(form)
      if (!form.isConnected) continue
      this.pending = form
      this.submittedValue = form.elements.campaign_status.value
      form.requestSubmit()
      break
    }
  }

  finish(event) {
    const form = event.currentTarget
    if (form !== this.pending) return
    this.pending = null
    this.queue.delete(form)
    if (!event.detail.fetchResponse) { this.queue.clear(); return }
    if (event.detail.success && form.isConnected && form.elements.campaign_status.value !== this.submittedValue) this.queue.add(form)
    this.saveNext()
  }
}
